import { useAtom } from 'jotai';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import { Box, Typography, Tab, Tabs } from '@mui/material';

import Licenses from './Licenses';
import ListUser from './ListUsers';
import '../scss/Pages/_config.scss';
import ListRoles from './ListRoles';
import { useUserPermissions } from '../hooks/userPermissions';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import { currentConfigTabAtom } from '../stores/configTabsStore';
import ConfigAlerts from '../components/ConfigTabSections/ConfigAlerts';
import { ConfigVisitTypes } from '../components/Tables/VisitTypesTable';
import ConfigReports from '../components/ConfigTabSections/ConfigReports';
import ConfigProfile from '../components/ConfigTabSections/ConfigProfile';
import { ConfigAllQuestionnaires } from '../components/Tables/QuestionnairesTable';

const Config = () => {
  const [tabIndex, setTabIndex] = useAtom(currentConfigTabAtom);
  const userPermissions = useUserPermissions();

  const {
    settingsMQString,
    settingsMVtypesString,
    settingsString,
    titleConfigString,
    usersString,
    rolesString,
  } = useTranslationHook();

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  const hideTab = (permission) => {
    if (userPermissions.includes(permission)) return false;

    return true;
  };

  return (
    <div className='config-container'>
      <Helmet>
        <title>{titleConfigString}</title>
      </Helmet>
      <ToastContainer />
      <Typography className='title'>{settingsString}</Typography>
      <Box
        sx={{
          borderBottomWidth: 1,
          borderBottomColor: '#E8EDEB',
          borderBottomStyle: 'solid',
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          sx={{
            '& button': {
              color: '#bdc4c1',
              padding: '20px',
              textTransform: 'none',
              fontSize: '1rem',
            },
            '& button.Mui-selected': { fontWeight: 'bold', color: '#464C4F' },
          }}
          TabIndicatorProps={{
            className: 'tabStyle',
          }}
        >
          <Tab label='Perfil' sx={{ textDecoration: 'none' }} />
          <Tab
            label={usersString}
            sx={{ textDecoration: 'none' }}
            hidden={hideTab('List Users')}
          />
          <Tab
            label={rolesString}
            sx={{ textDecoration: 'none' }}
            hidden={hideTab('Crear Roles')}
          />
          <Tab
            label={'Licencias'}
            sx={{ textDecoration: 'none' }}
            hidden={hideTab('Read Licenses')}
          />
          <Tab
            label={settingsMQString}
            sx={{ textDecoration: 'none' }}
            hidden={hideTab('List Questionaries')}
          />
          <Tab
            label={settingsMVtypesString}
            sx={{ textDecoration: 'none' }}
            hidden={hideTab('List Visit Types')}
          />
          <Tab label={'Reportes'} sx={{ textDecoration: 'none' }} />
          <Tab label={'Alertas'} sx={{ textDecoration: 'none' }} />
        </Tabs>
      </Box>

      <div className='config-content'>
        {tabIndex === 0 && (
          <div className='config-datatable-container'>
            <ConfigProfile />
          </div>
        )}
        {tabIndex === 1 && (
          <div className='config-datatable-container'>
            <ListUser />
          </div>
        )}
        {tabIndex === 2 && (
          <div className='config-datatable-container'>
            <ListRoles />
          </div>
        )}
        {tabIndex === 3 && (
          <div className='config-datatable-container'>
            <Licenses />
          </div>
        )}
        {tabIndex === 4 && (
          <div className='config-datatable-container'>
            <ConfigAllQuestionnaires />
          </div>
        )}
        {tabIndex === 5 && (
          <div className='config-datatable-container'>
            <ConfigVisitTypes />
          </div>
        )}
        {tabIndex === 6 && (
          <div className='config-datatable-container'>
            <ConfigReports />
          </div>
        )}
        {tabIndex === 7 && (
          <div className='config-datatable-container'>
            <ConfigAlerts />
          </div>
        )}
      </div>
    </div>
  );
};

export default Config;
